import React, { Component } from 'react';
import { Map, Marker, Popup, TileLayer, Tooltip as MarkerTooltip } from 'react-leaflet';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';  
import { LinkContainer } from 'react-router-bootstrap'
import { ResponsiveContainer, AreaChart, Tooltip, XAxis, YAxis, Area, ReferenceArea, ReferenceLine, LabelList } from 'recharts';
import { observer } from 'mobx-react'
import sensors from '../../stores/sensors'
import Loading from '../../Loading'
import { observable, computed } from "mobx";
import { withRouter } from 'react-router'
import ReactTimeout from 'react-timeout'
import Spiderfy from "../../components/Spiderfy";
import ChartToolTip from "../../components/ChartToolTip"
import parse from 'html-react-parser'
import './Location.css';

var alarmHeight;
var alarms;

export default withRouter(ReactTimeout(observer(class Location extends Component {

  @observable sensorName = null
  @observable sensorSlug = null

  refreshTimers = []

  constructor(props) {
      super(props);

      if(props.match.params.slug) {
        this.sensorSlug = props.match.params.slug
      }
  }

  componentDidMount() {
    if(sensors.length === 0 && !sensors.isRequest('fetching')) {
      sensors.fetch()
    }
  }

  changeSensor(slug) {
    this.clearRefreshTimers()
    this.sensorSlug = slug;
    this.props.history.push('/location/' + this.sensorSlug)
  }

  @computed get getsensor () {
    var sensor = sensors.find({'slug': this.sensorSlug})
    if(typeof sensor !== 'undefined') {
      sensor.fetchChartData()
      this.scheduleRefresh(sensor)
    }

    return sensor
  }

  @computed get getAlarms() {
    alarms = []
    
    this.getsensor.alarms.forEach(function(alarm, i)
    {
      alarms.push({height: alarm.height,
                  i: i,
                  number: alarm.order_number,
                  description: alarm.description});
    })

    return alarms
  }

  scheduleRefresh() {
    var id
    id = this.props.setTimeout(()=>{
      this.clearRefreshTimers() // Nuke any existing timers

      var sensor = this.getsensor
      sensor.fetchChartData()
      this.scheduleRefresh(sensor)
    }, 5*60*1000)

    this.refreshTimers.push(id)
  }

  clearRefreshTimers() {
    var id
    while((id = this.refreshTimers.pop()) != null) {
      this.props.clearTimeout(id)
    }

  }

  tickLabelFormatter(tick)
  {
    var labels = this.getsensor.chartYTickLabels

    return labels[tick]
  }

  renderMainAlarmHeightLabel(props)
  {
    const { viewBox } = props
    const { x, y } = viewBox

    return (
        <g>
        <polygon fill="#FB3C07" strokeWidth="2" stroke="#000"
                    points={(x-19) + "," + (y-12) + " " +
                            (x+56) + "," + (y-12) + " " +
                            (x+80) + "," + y + " " +
                            (x+56) + "," + (y+13) + " " +
                            (x-19) + "," + (y+13)} />
        <text x={x+22} y={y+1} fill="#000" textAnchor="middle" dominantBaseline="middle">
          {alarmHeight}mm
        </text>
        </g>
      );

  }

  // Render function for normal alarm lines
  renderAlarmLabel(props)
  {
    const { viewBox, value } = props
    const { x, y } = viewBox
    
    return (
        <g>
          <circle cx={x} cy={y} r={12} fill={"#fff"} strokeWidth="2" stroke="#000" />
        
          <text x={x} y={y+2} fill="#000" textAnchor="middle" dominantBaseline="middle">
            { value }
          </text>
        </g>
      );

  }

  render() {
    if (sensors.isRequest('fetching')) {
      return <Loading label='sensor' />
    }

    if(!this.getsensor)
    {
      return (
        <Card>
          <h4>Not found!</h4>
          <p>&nbsp;</p>
          <p>
            <Button href='/'>Back to communities map</Button>
          </p>
        </Card>
      )
    }

    if(this.getsensor.chartDataLoaded !== true)
    {
      return <Loading label='chart' />
    }

    var mappableSensors = []

    sensors.models.forEach(function(sensor, currentSensorSlug)
      {
        if (sensor.latlong[0] !== 0 || sensor.latlong[1] !== 0) {
          mappableSensors.push(sensor)
        }
      }
    )

    

    alarmHeight = this.getsensor.get("default_alarm_depth")

    const ref = React.createRef();

    return (
      <div>
        <Row>
          <Col xs={12}>
            <h1>{this.getsensor.get("name")}</h1>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            { this.getsensor.has("content_above") ? parse(this.getsensor.get("content_above")) : null }
          </Col>
        </Row>
        <Row>
          <Col xs={{span: 12, order: 1}} md={{span: 8, order: 2}}>
              <ResponsiveContainer aspect={1.5}>
                <AreaChart data={this.getsensor.filteredChartData} margin={{left: 20}} height={500}  baseValue={'dataMin'}>
                  <XAxis type="number"
                         domain={this.getsensor.chartXDomain}
                         dataKey="unixtime"
                         tickFormatter={tick => this.tickLabelFormatter(tick)}
                         ticks={this.getsensor.chartYTicks}
                         interval={0}
                         name="Time" />
                  <YAxis domain={this.getsensor.chartDataDomain}
                         orientation="right"/>
                  <Tooltip ref={ref} content={<ChartToolTip/>}/>


                  { this.getsensor.get("default_alarm_depth") > 0 ?
                      [<ReferenceArea key="green" y2={this.getsensor.get("default_alarm_depth")} stroke="none" fill="#35FF09" fillOpacity={1} />,
                      <ReferenceArea key="red" y1={this.getsensor.get("default_alarm_depth")} stroke="none" fill="#FB3C07"  fillOpacity={1} />,
                      <ReferenceLine ref={ref} key="community-alarm" y={this.getsensor.get("default_alarm_depth")} stroke="black" strokeWidth={2} label={this.renderMainAlarmHeightLabel}/>]
                    :
                      <ReferenceArea key="green" stroke="none" y2={this.getsensor.chartDataDomain[1]} fill="#35FF09" fillOpacity={1} />
                  }

                  { this.getAlarms.map(alarm => (
                    <ReferenceLine ref={ref} key={alarm.i} y={alarm.height} stroke="black" strokeWidth={2} label={<this.renderAlarmLabel value={alarm.number} />}/>
                  ))}

                  <Area type="monotone" dataKey="depth" fill="#15ADFF" fillOpacity={1} stroke="black" strokeWidth={2} isAnimationActive={false}>
                    <LabelList dataLength={this.getsensor.filteredChartData.length} dataKey="depth" content={renderLatestReadingLabel} />
                  </Area>

                </AreaChart>
              </ResponsiveContainer>
          </Col>

          <Col xs={{span: 11, order: 2}} md={{span: 4, order: 1}}>
            <Map
              center={this.getsensor.latlong}
              zoom={14}
              maxZoom={14}
              maxNativeZoom={14}
              style={{ height: '480px' }}
            >
                <TileLayer
                  url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                />
                <Spiderfy>
                  {
                      mappableSensors.map(sensor => (
                        <Marker key={sensor.get('slug')} position={sensor.latlong}>

                          {/* The current sensor gets a fixed tooltip */}
                          { sensor.get('slug') === this.sensorSlug &&
                            <MarkerTooltip permanent direction="top">
                              <div>
                                <h5>{sensor.get('name')}</h5>
                              </div>
                            </MarkerTooltip>
                          }

                          {/* Other sensors get a clickable popup */}
                          { sensor.get('slug') !== this.sensorSlug &&
                            <Popup className="rt-popup">
                              <span>
                                <h5>{sensor.get('name')}</h5>
                                <LinkContainer to={`/location/${sensor.get('slug')}`} onClick={() => this.changeSensor(sensor.get('slug'))}>
                                  <Button>Show...</Button>
                                </LinkContainer>
                              </span>
                            </Popup>
                          }
                        </Marker>
                      ))
                  }
                </Spiderfy>
              </Map>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
          { this.getAlarms.map(alarm => (
            <div key={ alarm.number }>
              <div className="alarm-marker">{ alarm.number }</div>
              <span>{ alarm.description }</span>
            </div>
          ))}
          <br />
          { this.getsensor.has("content_below") ? parse(this.getsensor.get("content_below")) : null }
          </Col>
        </Row>

      </div>
    )}

})))

// 



const renderLatestReadingLabel = (props) => {
  const { x, y, value, index, dataLength } = props;
  const radius = 3;

  // Only add the now box to the last element
  if(dataLength-1 !== index)
  {
    return
  }

  // Don't add label if the last value is null
  if(null === value)
  {
    return
  }

  return (
    <g>
    <circle cx={x} cy={y} r="8" fill="#000"/>
    <polygon fill="#fff" strokeWidth="2" stroke="#000"
                points={(x+20) + "," + (y-12) + " " +
                        (x+81) + "," + (y-12) + " " +
                        (x+81) + "," + (y+13) + " " +
                        (x+20) + "," + (y+13) + " " +
                        x + "," + y} />
     <circle cx={x} cy={y} r="6" fill="#FFF"/>
     <circle cx={x} cy={y} r={radius} fill="#000"/>
     <text x={x+47} y={y+1} fill="#000" textAnchor="middle" dominantBaseline="middle">
        {value}mm
     </text>
    </g>
  );
}



// WEBPACK FOOTER //
// ./src/routes/location/Location.js